import {
    GET_USER_LIST,
    SERCH_USER,
    SET_USER_ACTIVE,
    SET_USER_ACTIVE_LIST,
    GET_CURRENT_USER
} from '../actions/UserSettingActions'

const initialState = {
    userList: [],
    userSearchList:[],
    currentUser: null,
    pageSize: 20,
    total: 0,
    totalPages: 0,
    items:0,
    currentPage:0
}

const UserSettingReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_CURRENT_USER: {
            return {
                ...state,
                currentUser: { ...action.payload }
            }
        }
        case GET_USER_LIST: {
            //let ur = {...action.payload}
            return {
                ...state,
                userList: action.payload,
            }
        }
        case SERCH_USER: {
            return {
                ...state,
                userSearchList: action.payload.content,
            }
        }
        case SET_USER_ACTIVE: {
            return {
                state
            }
        }
        case SET_USER_ACTIVE_LIST: {
            return {
                state
            }
        }
        default: {
            return state
        }
    }
}

export default UserSettingReducer
